require('dotenv').config();
// export const APP_KEY = process.env.REACT_APP_APP_KEY;
// export const API_URL = process.env.REACT_APP_BASE_URL;
// export const API_URL = "http://localhost:2000";
// export const API_URL = "http://srpay1.com:3000";
// export const API_URL = "http://ec2-13-232-170-198.ap-south-1.compute.amazonaws.com:3000";
export const API_URL = process.env.REACT_APP_API_URL;  //"https://srpay1.com:3001"; // SRPAY-1
export const APP_KEY = "srpay";